import React from 'react';
import { Pressable, StyleSheet, Text } from 'react-native';
import { useAuth } from '../auth/AuthProvider';
import { makeThemedStyles } from '../v10/theme';
import { GlassCard } from '../v10/ui';
import type { StepItem } from './StepScreen';
import { useSharedTodayData } from './TodayDataContext';

// Persistent now-item strip — see docs/OLMPS_V8_SPEC.md "The two ORDER
// tables" → "Persistent now-item". Renders under the header whenever it's
// 10:00–20:00 and there's a current/next METIS item today; hidden otherwise.
export function NowStrip({ onOpenStep }: { onOpenStep: (item: StepItem) => void }) {
  const styles = useStyles();
  const { session } = useAuth();
  const userId = session?.user.id;
  const data = useSharedTodayData();

  if (!userId || data.loading || data.error) return null;

  const hour = data.now.getHours() + data.now.getMinutes() / 60;
  if (hour < 10 || hour >= 20) return null;

  const item = data.currentItem ?? data.nextItem;
  if (!item) return null;

  return (
    <Pressable
      style={styles.pressWrap}
      onPress={() =>
        onOpenStep({
          id: item.itemId,
          rowId: item.rowId,
          text: item.text,
          time: item.time || undefined,
          durationMinutes: item.durationMinutes,
        })
      }
    >
      <GlassCard style={styles.strip}>
        <Text style={styles.text} numberOfLines={1}>
          NOW · {item.text}
          {item.time ? ` · ${item.time}` : ''}
        </Text>
      </GlassCard>
    </Pressable>
  );
}

const useStyles = makeThemedStyles(({ t }) =>
  StyleSheet.create({
    pressWrap: { marginHorizontal: 12, marginBottom: 6 },
    strip: {
      paddingHorizontal: 14,
      paddingVertical: 8,
      borderRadius: 999,
      borderWidth: 1,
      borderColor: t.gold,
      boxShadow: `0 0 12px ${t.goldGlow}`,
    },
    text: { fontSize: 12, fontWeight: '800', letterSpacing: 1, color: t.goldBright },
  }),
);
